<template>
    <div v-if="artists && artists.length > 0">
        <ul class="flex flex-wrap items-baseline gap-x-1 text-sm text-nomad-300">
            <li class="text-nomad-400">feat.</li>
            <li v-for="(artist, index) in artists" :key="artist.id">
                <Link :href="'/artist/' + artist.id" class="text-nomad-100 transition-colors hover:text-nomad-accent">{{ artist.name }}</Link><span v-if="index !== artists.length - 1">,</span>
            </li>
        </ul>
    </div>
</template>
<script setup>
defineProps({ artists: Object });
</script>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
    },
};
</script>